import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import baseDialogPropTypes from './baseDialogPropTypes';
/*
 * Save dialog component to save, discard or cancel an action
 */
const SaveDialog = props => {
    const { content, onClickDiscard, discardButtonText, onClickCancel, cancelButtonText, onClickConfirm, confirmButtonText } = props, remainingProps = __rest(props, ["content", "onClickDiscard", "discardButtonText", "onClickCancel", "cancelButtonText", "onClickConfirm", "confirmButtonText"]);
    const footer = (_jsxs("div", Object.assign({ className: 'display-flex justify-content-end btn-toolbar' }, { children: [_jsx("button", Object.assign({ type: 'button', className: 'DiscardButton btn btn-default', onClick: onClickDiscard }, { children: discardButtonText })), _jsx("button", Object.assign({ type: 'button', className: 'CancelButton btn btn-default', onClick: onClickCancel }, { children: cancelButtonText })), _jsx("button", Object.assign({ type: 'button', className: 'ConfirmationButton btn btn-primary', onClick: onClickConfirm }, { children: confirmButtonText }))] })));
    return (_jsx(Dialog, Object.assign({}, remainingProps, { body: content, footer: footer, onHide: onClickCancel, className: 'save-dialog', disableEsc: true })));
};
SaveDialog.defaultProps = {
    show: false,
    showCloseButton: true,
    onClickCancel: () => { },
    onClickConfirm: () => { },
    onClickDiscard: () => { },
};
SaveDialog.propTypes = Object.assign(Object.assign({}, baseDialogPropTypes), { content: PropTypes.node, onClickCancel: PropTypes.func.isRequired, onClickDiscard: PropTypes.func.isRequired, onClickConfirm: PropTypes.func.isRequired, discardButtonText: PropTypes.node.isRequired, cancelButtonText: PropTypes.node.isRequired, confirmButtonText: PropTypes.node.isRequired });
export default SaveDialog;
